baseApp.directive('ngForm', ['$timeout', '$filter', 'GeneralUtilsService',  function($timeout, $filter, GeneralUtilsService) {
    return {
        transclude: true,
        templateUrl: '/public/directives/form.html',
        scope: {
            model: "=",
            entity: "@model",
            formType: "@",
            save: "@",
            clientSideValidation: "&?",
            reload: "@",
            buttonName: "@",
            modal: "=",
            title: "@",
            customButtons: "@",
            buttonsAbove: "@",
            noButtons: "@",
            hideCancelButton: "@",
            saveMessage: "@",
            formSize: "@"
        },
        controller: ['$scope','$location','$rootScope','$state', function($scope,$location,$rootScope,$state) {
        
           if(!$scope.formSize) $scope.formSize = "lg";
        
           $scope.goBack = ($scope.entity != 'site' && $scope.entity != 'account');
           
           $scope.saveButtonLabel = "Save";
           if($scope.buttonName){
             $scope.saveButtonLabel = $scope.buttonName;
           }
            if(!$scope.save){
                $scope.save = "edit";

            }
            $scope.firstTime = true;
            $scope.edit = function() {
                if($scope.$parent.customEdit){
                   $scope.$parent.customEdit();
                }
                else {
                    $scope.editEntity(false);
                }
            };

            $scope.validate = function(){
                if($scope.formType == 'new'){
                    $scope.addEntity(true);
                }
                else {
                    $scope.editEntity(true);
                }
            };
            $scope.reloadPage = function(){
               location.href = location.href;
            };
            $scope.editEntity = function(validationOnly){
                var goBack = $scope.goBack;
            
                if($scope.$parent.preSave){
                   $scope.$parent.preSave();
                }

                if ($scope.clientSideValidation && !$scope.clientSideValidation()) {
                    return;
                }

                var data = GeneralUtilsService.getParams($location,true);
                var model = $scope.model;
                var modelName = $filter('capitalize')($scope.entity);
                var useForm = ((!model || !model.id) && $scope.formData);
                var prefix = useForm?"formData":$scope.entity.toLowerCase();
           
                var params = {};
                if(data){
                    params.data = data;
                }
                else {
                    params[$scope.entity + "Id"] = model.id;
                }

                params.save = !validationOnly;
                params.type = $scope.entity;

                if(useForm){
                    model = $scope.formData;
                }
                store.save({
                    data: model,
                    dataObj: 'json',
                    path: $scope.save,
                    queryParams: params,
                    success: function(data) {
                        if(validationOnly){
                            $scope.$root.handleServerResponse(data,prefix);
                        }
                        else {
                            if($scope.reload){
                                $scope.$root.handleServerResponse(data,prefix,modelName + " saved successfully", $scope.reloadPage);
                            }
                            else {
                                $scope.$root.handleServerResponse(data,prefix,modelName + " saved successfully" ,
                                    function(){
                                        if(goBack) {
                                            window.history.back();
                                        }
                                        else {
                                            if($scope.$parent.postSave){
                                                $scope.$parent.postSave();
                                            }
                                        }
                                    });
                            }
                        }
                    }
                });
            };
            $scope.addEntity = function(validationOnly) {

                var accountId = $state.params.accountId;
                var current = $scope.$parent.getCurrent();
                var model = $scope.model;
                if(typeof model != 'object'){
                  model = $scope.$parent.formData;
                }
                var type = $state.current.type;

                var params = {};
                params[current.modelKey] = current.modelId;
                params.save = !validationOnly;
                params.accountId = accountId;
                params.type = type;


                if($scope.$parent.preSave){
                   $scope.$parent.preSave();
                }

                store.save({
                    data: model,
                    dataObj: 'json',
                    path: '/add',
                    queryParams: params,
                    success: function (data) {
                        if(validationOnly){
                            $scope.$root.handleServerResponse(data,$scope.entity.toLowerCase());
                        }
                        else {
                            var afterAddition = $scope.back;
                            var saveMessage = $scope.saveMessage?$scope.saveMessage:type + " added successfully";
                            $scope.$root.handleServerResponse(data, $scope.entity.toLowerCase(), saveMessage , afterAddition);

                        }
                    }
                });
            };

            $scope.back = function(){
                if($scope.goBack){
                   window.history.back();
                }
            }

            $scope.cancelSubmit = function() {
                if ($scope.noButtons) return false;
            }
        }]
    };
}]);